import React from 'react';
import { withStyles } from '@mui/styles';

import ArrowTooltipCss from './ArrowTooltipCss';
import ComponentWrapper from './ComponentWrapper';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const styles = {
  btn: {
    color: '#C4C4C4',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  form: {
    zIndex: '-1',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    position: 'relative',
  },
};

class CopyBtn extends ComponentWrapper {
  copyToClipboard = () => {
    navigator.clipboard.writeText(this.props.text);

    this.notify('info', `Text copied to clipboard`, 3);
  };

  render() {
    const { classes, copyIconStyles } = this.props;

    return (
      <ArrowTooltipCss text="Copy to clipboard">
        <button className={classes.btn} style={{ display: 'flex' }} onClick={() => this.copyToClipboard()}>
          <ContentCopyIcon style={{ ...copyIconStyles }}/>
        </button>
      </ArrowTooltipCss>
    );
  }
}

export default withStyles(styles)(CopyBtn);
